import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { IconButton } from '@pets-ui/IconButton/IconButton'
import { CloseSmall } from '@pets-ui/icons'
import PdfFileIcon from '@pets-ui/Icons/assets/pdf-file-icon.webp'
import { Image } from '@pets-ui/Image/Image'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { type ReactNode } from 'react'

const styles = stylex.create({
  container: {
    padding: '12px',
    borderColor: colors.grey300,
    borderRadius: '4px',
    borderStyle: 'solid',
    borderWidth: '1px',
    alignItems: 'flex-start',
    boxSizing: 'border-box',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    position: 'relative',
    width: '100%',
  },
  fileIconContainer: {
    borderRadius: '12px',
    overflow: 'hidden',
    alignItems: 'center',
    backgroundColor: colors.grey200,
    display: 'flex',
    justifyContent: 'center',
    height: '80px',
    width: '80px',
  },
  closeButton: {
    color: colors.grey500,
    position: 'absolute',
    right: '12px',
    top: '12px',
  },
  fileNameContainer: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '200px',
  },
})

export interface AiUploadedFileProps {
  fileName: string
  fileSize: number
  icon?: ReactNode
  onRemove: () => void
}

const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return `${(bytes / Math.pow(k, i)).toFixed(2)}${sizes[i]}`
}

export const AiUploadedFile = ({
  fileName,
  fileSize,
  icon = <Image src={PdfFileIcon} />,
  onRemove,
}: AiUploadedFileProps) => {
  const formattedSize = formatFileSize(fileSize)
  return (
    <HStack rootStyle={styles.container}>
      <HStack gap={3} justifyContent="flex-start" alignItems="center">
        <Box rootStyle={styles.fileIconContainer}>
          {icon}
        </Box>
        <VStack justifyContent="flex-start" width="100%" flex={1} paddingRight={5}>
          <Text variant="body" color={colors.grey900}>
            {fileName}
          </Text>
          <Text variant="body" color={colors.grey600}>
            {formattedSize}
          </Text>
        </VStack>
      </HStack>
      <IconButton onClick={onRemove} size="small" rootStyle={styles.closeButton}>
        <CloseSmall />
      </IconButton>
    </HStack>
  )
}
